import axiosConfig from "../../../../../config/axiosConfig";

const API = () => {
  const getTodoListByCategory = async (params: any) => {
    const url = "/todo-task/list";
    return (await axiosConfig.get(url, { params })).data;
  }; 

  const getProjectById = async (params: any): Promise<any> => {
    try {
      const url = "/project/detail";
      const response = await axiosConfig.get(url, { params });
      return response?.data;
    } catch (error) {
      throw error;
    }
  };
  
  return { getTodoListByCategory, getProjectById };
};

export default API;
